import axios from "axios";
import Cookies from "../components/cookies";
import config from "../config";


const handleExpiredToken = () => {
    window.location = "/";
}


export const DashboardInstances = async (company_id) =>{

    const CookieObj = new Cookies();
    let access_token = CookieObj.getCookie("token")
    var dashboard_instances = [];
    axios.defaults.baseURL = config.servers["base"];
    let urlTOload = `instances/get/`
    
    await axios.post(
        urlTOload,
        {
            company_id: company_id
        },
        {
            headers:{
                authorization : "Bearer " + access_token 
            }
        }
    ).then((response)=>{
        if(response.status === 401){
            handleExpiredToken();
        }
        dashboard_instances = response.data;
    }).catch(error=>{
        if(error.response.status === 401)
        {   
            handleExpiredToken();
        }
        else{
            dashboard_instances = [] 
        }
    })
    return await dashboard_instances

}